export const DISPATCH_FILTER_TOGGLE = 'DISPATCH_TOGGLE_FILTER';

export const filterToggle = function (type, value) {
  return {
    type: DISPATCH_FILTER_TOGGLE,
    filterType : type,
    value: value
  };
};
